import { render, staticRenderFns } from "./QuestionPaperEdit.vue?vue&type=template&id=20457295&scoped=true&"
import script from "./QuestionPaperEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionPaperEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPaperEdit.vue?vue&type=style&index=0&id=20457295&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20457295",
  null
  
)

export default component.exports